import React, { FC, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ReactComponent as Refresh } from "images/Refresh.svg";
import { AddToSelectionList, RemoveFromSelectionList } from "toolkit/steps/stepThree/stepThree.slice";
import NewCheckBox from "components-new/NewCheckBox";
import styles from "./SelectObjectListItem.module.sass";
import Tooltip from "components-new/Tooltip";

interface SelectObjectListItemProps {
	object: any;
}

export const SelectObjectListItem: FC<SelectObjectListItemProps> = ({ object }) => {
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const { selectionList } = useAppSelector((state) => state.stepThree);
	const dispatch = useAppDispatch();

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCheckbox(e.target.checked);
		if (e.target.checked) dispatch(AddToSelectionList({ id: object.objectId, name: object.name }));
		else dispatch(RemoveFromSelectionList(object.objectId));
	};

	useEffect(() => {
		if (selectionList.length) {
			selectionList.forEach((item) => {
				if (item.id === object.objectId && item.name === object.name) {
					setCheckbox(true);
				}
			});
		} else {
			setCheckbox(false);
		}
		//eslint-disable-next-line
	}, [selectionList]);

	// useEffect(() => {
	//     if (allChecked) {
	//         selectionList.forEach(item => {
	//             if (item.id === object.objectId) setCheckbox(true);
	//         })
	//     }
	//     else if (!allChecked && allChecked !== null) {}setCheckbox(false);
	//
	// }, [allChecked])

	return (
		<li className={styles["list-elements-item"]}>
			<Tooltip
				show={!!object?.reselection}
				delay={200}
				menu={<div className={styles.tooltip}>Этот объект будет проходить повторное категорирование</div>}
				color="themeWhite">
				<label
					htmlFor={`connection-${object.objectId || object.objectTypeId}`}
					className={styles["list-elements-label"]}>
					<NewCheckBox
						checked={checkbox}
						onChange={changeHandler}
						type="checkbox"
						id={`connection-${object.objectId || object.objectTypeId}`}
					/>
					{object.reselection && (
						<div className={styles.icon}>
							<Refresh />
						</div>
					)}
					<span className={styles["list-elements-value"]}>{object.name}</span>
				</label>
			</Tooltip>
		</li>
	);
};
